import { createUseStyles } from "react-jss";
import * as Mixins from "../../../theme/Mixins";

export default createUseStyles({
    fieldset: {
        minInlineSize: "auto",
    },
    question: {
        composes: "question",
        position: "relative",
        margin: ({ theme }) => [
            [
                Mixins.getSpacing(
                    theme,
                    theme.QuestionSpacing,
                    theme.QuestionSpacing?.BetweenComponents,
                ),
                -29,
            ],
        ],
        padding: ({ theme }) => [
            [Mixins.getSpacing(theme, 0, theme.QuestionSpacing?.WithinComponents), 29],
        ],
        "& img, video, iframe": {
            maxWidth: "100%",
        },
    },
    questionLegend: {
        composes: "question__legend",

        /* Set width of <legend> encapsulating the question label to fix text-wrapping of long questions in IE11 */
        width: "100%",
    },
    questionName: {
        composes: "question__name",
        lineHeight: `inherit`,
        marginTop: ({ theme }) => Mixins.getSpacing(theme, 29, 0),
        marginBottom: ({ theme }) => Mixins.getSpacing(theme, 14.5, 0),
    },
    questionTitle: {
        composes: "question__title",
    },
    questionText: {
        composes: "question__text",
        display: "block",
        textAlign: ({ theme }) => Mixins.getTextAlign(theme.TextTextAlign),
        wordWrap: "break-word",
        marginBottom: ({ theme }) => Mixins.getSpacing(theme, "0.5em", 0),
        padding: ({ theme }) => [[Mixins.getSpacing(theme, 0, 8), 0]],
    },
    questionContent: {
        composes: "question__content",
        marginTop: ({ theme }) => Mixins.getSpacing(theme, 29, 0),
    },
    questionShortText: {
        composes: "question__short-text",
    },
    questionError: {
        composes: "question--error",
    },
    questionValidation: {
        alignItems: "center",
        composes: "question__validation",
        display: "inline-flex",
    },
    questionValidationFocus: {
        borderLeftColor: ({ theme }) => theme.ErrorColor,
        composes: "question__validation-focus",
    },
    dynamicQuestionValidationFocus: {
        borderLeftStyle: "solid",
        borderLeftWidth: 3,
        left: -30,
        paddingLeft: 30,
        position: "relative",
        width: "100%",
    },
});
